// CommunicatorPlugin/common/schemas/collections/telephonyDIDs.js
import { z } from "zod";

const TelephonyDIDSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId as a string."),
    subscriptionId: z.string().optional().describe("The tenant this DID belongs to."),
    serviceCode: z.string().optional().describe("The service code of the subscription, for quick context resolution."),

    phoneNumber: z.string().describe("The full phone number in E.164 format (e.g., +15551234567)."),
    provider: z.string().describe("The provider of this number (e.g., 'twilio')."),
    providerChannelId: z.string().optional().nullable().describe("The _id of the corresponding record in the omniChannelConfigs collection."),
    inboundVoiceWorkflowId: z.string().optional().nullable().describe("The source workflow ID to execute for inbound voice calls to this DID."),

    metadata: z.record(z.any()).optional().default({}).describe("Flexible key-value store for additional data."),

    createdAt: z.coerce.date().optional(),
});

export default TelephonyDIDSchema;
